"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.demicrofy = exports.microfy = exports.MICRO = void 0;
var big_js_1 = __importDefault(require("big.js"));
// ---------------------------------------------
// micro
// ---------------------------------------------
exports.MICRO = 1000000;
function microfy(amount) {
    return big_js_1.default(amount).mul(exports.MICRO);
}
exports.microfy = microfy;
function demicrofy(amount) {
    return big_js_1.default(amount).div(exports.MICRO);
}
exports.demicrofy = demicrofy;
//# sourceMappingURL=currency.js.map